var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex"},[_c('EventText',{attrs:{"text":_vm.event.asText(_vm.activeEmployment),"event-text-class":'tw-flex-1 tw-mr-3'}}),_c('AttachmentDate',{staticClass:"tw-text-sm tw-text-gray-555",attrs:{"date":_vm.event.getCreatedAt()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }